import requestHandler from 'portal-base/src/decorators/RequestHandler';

class ChannelRepository {
    static target = portalConfig.portalBaseUrl;

    setTarget(target) {
        ChannelRepository.target = target;
    }

    @requestHandler()
    getChannelMetaData(chanId) {
        const url = `${ChannelRepository.target}shares/channels/${chanId}?format=json`;
        return fetch(url);
    }

    @requestHandler()
    getTimeseriesMeta(channelId) {
        const url = `${ChannelRepository.target}shares/channels/${channelId}/timeSeries/?includeLocationData=true&includeChannelData=true`;
        return fetch(url);
    }

    @requestHandler()
    getLastValues(channelId) {
        const url = `${ChannelRepository.target}shares/channels/${channelId}/timeSeries/lastValues`;
        return fetch(url);
    }
}

export const ChannelStore = new ChannelRepository();
